import { createReducer } from '@reduxjs/toolkit';

import { setCurrentPage } from '../thunks/currentPage.thunks';

import type { CurrentPageState } from '../../types/state.types';

const initialState: CurrentPageState = {};

export const currentPageReducer = createReducer(initialState, (builder) =>
  builder.addCase(setCurrentPage, (state, action) => {
    state.id = action?.payload?.currentPage.id;
    state.group = action?.payload?.currentPage.group;
    state.params = action?.payload?.currentPage.params;
  })
);
